// ============================================================================
// Plan Configuration - Single source of truth for plan features
// ============================================================================

export type PlanTier = 'free' | 'basico' | 'ilimitado';
export type BillingPeriod = 'MONTHLY' | 'YEARLY';

// Features por tier (usa i18n keys de billing.features)
export const PLAN_FEATURES_BY_TIER: Record<PlanTier, string[]> = {
  free: [
    'billing.features.oneDnaPerCategory',
    'billing.features.tenInspirationsMonth',
    'billing.features.tenAiMessagesDay',
    'billing.features.basicAiModels',
    'billing.features.onePrompt',
  ],
  basico: [
    'billing.features.fourDnasPerCategory',
    'billing.features.thirtyInspirationsWeek',
    'billing.features.allAiModels',
    'billing.features.unlimitedAiMessages',
    'billing.features.fourCustomPrompts',
  ],
  ilimitado: [
    'billing.features.unlimitedDnas',
    'billing.features.unlimitedInspirations',
    'billing.features.unlimitedAiMessages',
    'billing.features.allAiModels',
    'billing.features.unlimitedPrompts',
  ],
};

// Tier colors for UI styling
export const TIER_COLORS: Record<PlanTier, string> = {
  free: 'bg-gray-100 text-gray-700',
  basico: 'bg-blue-100 text-blue-700',
  ilimitado: 'bg-amber-100 text-amber-700',
};

// Helper para extrair tier do slug
export function extractTierFromSlug(slug: string): PlanTier {
  const s = slug.toLowerCase();
  if (s.includes('ilimitado') || s.includes('unlimited')) return 'ilimitado';
  if (s.includes('basico') || s.includes('basic') || s.includes('starter')) return 'basico';
  return 'free';
}

// Helper para obter features (i18n keys) de um plano
export function getPlanFeatures(slug: string): string[] {
  const tier = extractTierFromSlug(slug);
  return PLAN_FEATURES_BY_TIER[tier];
}

// Helper para verificar se é plano anual
export function isYearlyPlan(slug: string): boolean {
  const s = slug.toLowerCase();
  return s.includes('yearly') || s.includes('annual');
}

// Helper para obter o slug base (sem o período)
export function getBasePlanSlug(slug: string): string {
  return slug
    .replace('-monthly', '')
    .replace('-yearly', '')
    .replace('-annual', '');
}

// Helper para construir slug com período
export function buildPlanSlug(baseSlug: string, period: BillingPeriod): string {
  const base = getBasePlanSlug(baseSlug);
  if (base.includes('free')) return base; // Free não tem período
  return `${base}-${period.toLowerCase()}`;
}
